import Events from '@/hooks/events';
import actions from '../constants';

export default {
  useFetchRequestMarkdown: (category, { code }) => Events.useDispatchByCode(
    actions.FETCH_REQUEST_MARKDOWN,
    category,
    code,
  ),
};
